import { DocumentFeature } from '../../easyclaim.api.client.typescript/src/index';

export const pictureRejectionDocumentFeatures = [
	DocumentFeature.Screenshot,
	DocumentFeature.InvalidPicturePerspective,
	DocumentFeature.CutImages,
	DocumentFeature.DarkPictures,
	DocumentFeature.LowResolution,
	DocumentFeature.BadVisibility,
	DocumentFeature.ObstructedView,
	DocumentFeature.CameraEffectorEdition,
	DocumentFeature.RainSnowOrDirt,
	DocumentFeature.InvalidItv,
	DocumentFeature.InvalidPicture,
	DocumentFeature.InvalidVinNumber,
	DocumentFeature.WindowDown,
];
